export default "__VITE_ASSET__bd7d26e7__"